import { Component, OnInit, ElementRef } from '@angular/core';
import { TooltipComponent } from '@realpage-da/ng-map';
import { environment } from '~environment';
import { ColorConstants } from '~/shared/utils/color-constants';

@Component({
  selector: 'market-tooltip',
  templateUrl: './market-tooltip.component.html',
  styleUrls: ['./market-tooltip.component.scss']
})
export class MarketTooltipComponent extends TooltipComponent implements OnInit {
  data: any;
  baseImageUrl: string;
  topBorderColor: string = ColorConstants.CHARCOAL_LIGHT;

  constructor(public element: ElementRef) {
    super(element);
  }

  ngOnInit() {
    this.data = this.feature.data;
    this.baseImageUrl = `${environment.baseCdnUrl}/mkts/${this.feature.id}.jpg`;
  }
}



// WEBPACK FOOTER //
// ./src/app/features/market/components/map/market-tooltip.component.ts